// extracted by mini-css-extract-plugin
export default {"ButtonLeft":"CancelRejectButton_ButtonLeft__JmfhD","Button":"CancelRejectButton_Button__C0bbI"};